import TextField from '@mui/material/TextField';
import type { TextFieldProps } from '@mui/material/TextField';

type FaimTextInputProps = Omit<TextFieldProps, 'variant'> & {
  /** Renders as page-level search input (full-width, no label shrink) */
  search?: boolean;
};

/**
 * Reusable text input — wraps MUI TextField with FAIM2 defaults.
 * Use `search` prop for search bars, otherwise standard form field.
 */
export function TextInput({ search, ...props }: FaimTextInputProps) {
  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth={!search}
      sx={search ? { width: 320 } : undefined}
      {...props}
    />
  );
}
